export default __webpack_public_path__ + "static/province-top-bg-56def1414d1eb10a3eefeaba33332d9a.jpg";